import { Routes } from '@angular/router';
import { DashboardComponent } from './dashboard/dashboard.component';
import { BuildingComponent } from './building/building.component';
import { NsideIdentityGuard } from '../shared/services/auth/nSideIdentityGuard';
import { SpinnerComponent } from './components/spinner/spinner.component';
import { NotFoundComponent } from './not-found/not-found.component';

export const routes: Routes = [
    { 
        path: '', 
        redirectTo: 'dashboard', 
        pathMatch: 'full'
    },
    { 
        path: 'tips-queue/:buildingId/hasAssess/:hasAssess/canAssess/:userAssessPermission/region/:regionId', 
        component: BuildingComponent, 
        canActivate: [NsideIdentityGuard] 
    },
    { 
        path: 'dashboard', 
        component: DashboardComponent, 
        canActivate: [NsideIdentityGuard] 
    },
    {
        path: 'unauthorized',
        component: SpinnerComponent,
        data: { showSidebar: false }
    },
    { 
        path: '**', 
        component: NotFoundComponent,
        data: { showSidebar: false } 
    }
];
